<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>This book is dedicated to</span></p>
<p class="ded1"><span>Miss Elizabeth Wordsworth</span></p>
<p class="ded1"><span>and</span></p>
<p class="ded1"><span>all those brave women who opened the doors</span></p>
<p class="ded1"><span>to higher education for the rest of us to walk through</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?acb73732